import { memo } from 'react';

import { ReactComponent as IcAlibaba } from '../../assets/icons/ic_alibaba.svg';
import { ReactComponent as IcAlibabaCircle } from '../../assets/icons/ic_alibaba_circle.svg';
import { ReactComponent as IcAmazon } from '../../assets/icons/ic_amazon.svg';
import { ReactComponent as IcAppStoreBadge } from "../../assets/icons/ic_app_store_badge.svg";
import { ReactComponent as IcApple } from '../../assets/icons/ic_apple.svg';
import { ReactComponent as IcAppleCircle } from '../../assets/icons/ic_apple_circle.svg';
import { ReactComponent as IcArrowLeft } from '../../assets/icons/ic_arrow_left.svg';
import { ReactComponent as IcArrowRight } from '../../assets/icons/ic_arrow_right.svg';
import { ReactComponent as IcAttention } from "../../assets/icons/ic_attention.svg";
import { ReactComponent as IcBack } from "../../assets/icons/ic_back.svg";
import { ReactComponent as IcBank } from '../../assets/icons/ic_bank.svg';
import { ReactComponent as IcBankCard } from '../../assets/icons/ic_bank_card.svg';
import { ReactComponent as IcBankCardArrowRight } from '../../assets/icons/ic_bank_card_arrow_right.svg';
import { ReactComponent as IcBinomoLogo } from '../../assets/icons/ic_binomo_logo.svg';
import { ReactComponent as IcBitcoin } from '../../assets/icons/ic_bitcoin.svg';
import { ReactComponent as IcBonus } from "../../assets/icons/ic_bonus.svg";
import { ReactComponent as IcBonusStub } from "../../assets/icons/ic_bonus_stub.svg";
import { ReactComponent as IcBrent } from '../../assets/icons/ic_brent.svg';
import { ReactComponent as IcBtc } from '../../assets/icons/ic_btc.svg';
import { ReactComponent as IcChainLink } from '../../assets/icons/ic_chain_link.svg';
import { ReactComponent as IcCheckMark } from "../../assets/icons/ic_check_mark.svg";
import { ReactComponent as IcCheckMarkCircle } from '../../assets/icons/ic_check_mark_circle.svg';
import { ReactComponent as IcCheckMarkCircleGreen } from '../../assets/icons/ic_check_mark_circle_green.svg';
import { ReactComponent as IcCheckMarkShield } from "../../assets/icons/ic_check_mark_shield.svg";
import { ReactComponent as IcChevronDown } from "../../assets/icons/ic_chevron_down.svg";
import { ReactComponent as IcChevronLeft } from '../../assets/icons/ic_chevron_2_left.svg';
import { ReactComponent as IcChevronRight } from '../../assets/icons/ic_chevron_2_fight.svg';
import { ReactComponent as IcCisco } from '../../assets/icons/ic_cisco.svg';
import { ReactComponent as IcCiscoCircle } from '../../assets/icons/ic_cisco_circle.svg';
import { ReactComponent as IcCiti } from '../../assets/icons/ic_citi.svg';
import { ReactComponent as IcClock } from '../../assets/icons/ic_clock.svg';
import { ReactComponent as IcCoinStack } from "../../assets/icons/ic_coin_stack.svg";
import { ReactComponent as IcCopy } from "../../assets/icons/ic_copy.svg";
import { ReactComponent as IcCoupon } from "../../assets/icons/ic_coupon.svg";
import { ReactComponent as IcDash } from '../../assets/icons/ic_dash.svg';
import { ReactComponent as IcDocCopy } from "../../assets/icons/ic_doc_copy.svg";
import { ReactComponent as IcDollar } from '../../assets/icons/ic_dollar.svg';
import { ReactComponent as IcDowJones } from '../../assets/icons/ic_dow_jones.svg';
import { ReactComponent as IcEbay } from '../../assets/icons/ic_ebay.svg';
import { ReactComponent as IcEducation } from '../../assets/icons/ic_education.svg';
import { ReactComponent as IcEmptyPage } from "../../assets/icons/ic_empty_page.svg";
import { ReactComponent as IcEnvelope } from "../../assets/icons/ic_envelope.svg";
import { ReactComponent as IcEnvelopeCheckmark } from "../../assets/icons/ic_envelope_checkmark.svg";
import { ReactComponent as IcEth } from '../../assets/icons/ic_eth.svg';
import { ReactComponent as IcEthereum } from '../../assets/icons/ic_ethereum.svg';
import { ReactComponent as IcExclamationMarkCircle } from "../../assets/icons/ic_exclamation_mark_circle.svg";
import { ReactComponent as IcExclamationMarkTriangle } from "../../assets/icons/ic_exclamation_mark_triangle.svg";
import { ReactComponent as IcEyeOff } from '../../assets/icons/ic_eye_off.svg';
import { ReactComponent as IcEyeOn } from '../../assets/icons/ic_eye_on.svg';
import { ReactComponent as IcFacebook } from '../../assets/icons/ic_facebook.svg';
import { ReactComponent as IcFlags } from "../../assets/icons/ic_flags.svg";
import { ReactComponent as IcFlagsChfUsd } from '../../assets/icons/ic_flags_chf_usd.svg';
import { ReactComponent as IcFlagsEurUsd } from '../../assets/icons/ic_flags_eur_usd.svg';
import { ReactComponent as IcFlagsJpyEur } from '../../assets/icons/ic_flags_jpy_eur.svg';
import { ReactComponent as IcFlagsJpyUsd } from '../../assets/icons/ic_flags_jpy_usd.svg';
import { ReactComponent as IcFlagsUkUsd } from '../../assets/icons/ic_flags_uk_usd.svg';
import { ReactComponent as IcGas } from '../../assets/icons/ic_gas.svg';
import { ReactComponent as IcGear } from "../../assets/icons/ic_gear.svg";
import { ReactComponent as IcGearApp } from "../../assets/icons/ic_gear_app.svg";
import { ReactComponent as IcGold } from '../../assets/icons/ic_gold.svg';
import { ReactComponent as IcGoldCircle } from '../../assets/icons/ic_gold_circle.svg';
import { ReactComponent as IcGooglePlayBadge } from "../../assets/icons/ic_google_play_badge.svg";
import { ReactComponent as IcGraduationCap } from "../../assets/icons/ic_graduation_cap.svg";
import { ReactComponent as IcHarpoonLeftRight } from '../../assets/icons/ic_harpoon_2_left_right.svg';
import { ReactComponent as IcHp } from '../../assets/icons/ic_hp.svg';
import { ReactComponent as IcInfoCircle } from "../../assets/icons/ic_info_circle.svg";
import { ReactComponent as IcLtc } from '../../assets/icons/ic_ltc.svg';
import { ReactComponent as IcMicrosoft } from '../../assets/icons/ic_microsoft.svg';
import { ReactComponent as IcMoveLeft } from '../../assets/icons/ic_move_left.svg';
import { ReactComponent as IcNasdaq } from '../../assets/icons/ic_nasdaq.svg';
import { ReactComponent as IcNextRound } from '../../assets/icons/ic_next_round.svg';
import { ReactComponent as IcNgas } from '../../assets/icons/ic_ngas.svg';
import { ReactComponent as IcPassport } from '../../assets/icons/ic_passport.svg';
import { ReactComponent as IcPencil } from "../../assets/icons/ic_pencil.svg";
import { ReactComponent as IcPerson } from '../../assets/icons/ic_person.svg';
import { ReactComponent as IcPlay } from "../../assets/icons/ic_play.svg";
import { ReactComponent as IcPound } from '../../assets/icons/ic_pound.svg';
import { ReactComponent as IcQrCode } from "../../assets/icons/ic_qr_code.svg";
import { ReactComponent as IcQuestionMarkBubble } from '../../assets/icons/ic_question_mark_bubble.svg';
import { ReactComponent as IcReferrals } from '../../assets/icons/ic_referrals.svg';
import { ReactComponent as IcRespawn } from '../../assets/icons/ic_respawn.svg';
import { ReactComponent as IcSAndP } from '../../assets/icons/ic_s_and_p.svg';
import { ReactComponent as IcSAndPShort } from '../../assets/icons/ic_s_and_p_short.svg';
import { ReactComponent as IcSilverCircle } from '../../assets/icons/ic_silver_circle.svg';
import { ReactComponent as IcSquareArrowUpRight } from '../../assets/icons/ic_square_arrow_up_right.svg';
import { ReactComponent as IcStopwatch } from "../../assets/icons/ic_stopwatch.svg";
import { ReactComponent as IcTesla } from '../../assets/icons/ic_tesla.svg';
import { ReactComponent as IcTrades } from '../../assets/icons/ic_trades.svg';
import { ReactComponent as IcUnknownError } from "../../assets/icons/ic_unknown_error.svg";
import { ReactComponent as IcUsd } from '../../assets/icons/ic_usd.svg';
import { ReactComponent as IcWallet } from '../../assets/icons/ic_wallet.svg';
import { ReactComponent as IcXCircle } from "../../assets/icons/ic_x_circle.svg";
import { ReactComponent as IcXCircleRed } from '../../assets/icons/ic_x_circle_red.svg';
import { ReactComponent as IcXMark } from '../../assets/icons/ic_x_mark.svg';
import { ReactComponent as IcXMarkThin } from '../../assets/icons/ic_x_mark_thin.svg';
import { ReactComponent as Shield } from '../../assets/icons/shield.svg';
import { ReactComponent as IcClose } from '../../assets/icons/ic_close.svg';
import { ReactComponent as IcDocument } from '../../assets/icons/ic_document.svg';
import { ReactComponent as IcPersonGroup } from '../../assets/icons/ic_person_group.svg';
import { ReactComponent as IcRebuy } from '../../assets/icons/ic_rebuy.svg';
import { ReactComponent as IcPortfolio } from '../../assets/icons/ic_portfolio.svg';
import { ReactComponent as IcPlaceholder } from '../../assets/icons/ic_placeholder.svg';
import { ReactComponent as IcWarning } from '../../assets/icons/ic_warning.svg';
import { ReactComponent as IcGrowth } from '../../assets/icons/ic_growth.svg';
import { ReactComponent as IcReduction } from '../../assets/icons/ic_reduction.svg';
import { ReactComponent as IcWithdraw } from '../../assets/icons/ic_withdraw.svg';
import { ReactComponent as IcTransaction } from '../../assets/icons/ic_transaction.svg';
import { ReactComponent as IcPlusCircle } from '../../assets/icons/ic_plus_circle.svg';
import { ReactComponent as IcCheckCircle } from '../../assets/icons/ic_check_circle.svg';
import { ReactComponent as IcAssetDefault } from '../../assets/icons/ic_asset_default.svg';
import { ReactComponent as IcInfo } from '../../assets/icons/ic_info.svg';
import { ReactComponent as IcChartStatistic } from '../../assets/icons/ic_chart_statistic.svg';
import { ReactComponent as IcChartLine } from '../../assets/icons/ic_chart_line.svg';
import { ReactComponent as IcMenuBurger } from '../../assets/icons/ic_menu_burger.svg';
import { ReactComponent as IcMinus } from '../../assets/icons/ic_minus.svg';
import { ReactComponent as IcPlus } from '../../assets/icons/ic_plus.svg';
import { ReactComponent as IcCloseWhite } from '../../assets/icons/ic_close_white.svg';
import { ReactComponent as IcCountry } from "../../assets/icons/ic_country.svg";
import { ReactComponent as IcDelete } from "../../assets/icons/ic_delete.svg";
import { ReactComponent as IcFingerprint } from "../../assets/icons/ic_fingerprint.svg";
import { ReactComponent as IcChartCandle } from "../../assets/icons/ic_chart_candle.svg";
import { ReactComponent as IcSearch } from "../../assets/icons/ic_search.svg";
import { ReactComponent as IcInfoFilled } from "../../assets/icons/ic_info_filled.svg";
import { ReactComponent as IcCircleSlashed } from "../../assets/icons/ic_circle_slashed.svg";
import { ReactComponent as IcForward } from "../../assets/icons/ic_forward.svg";
import { ReactComponent as IcAttentionCircleWhite } from "../../assets/icons/ic_attention_circle_white.svg";
import { ReactComponent as IcCard } from "../../assets/icons/ic_card.svg";
import { ReactComponent as IcClockBlackCircle } from "../../assets/icons/ic_clock_black_circle.svg";
import { ReactComponent as IcDollarRefresh } from "../../assets/icons/ic_dollar_refresh.svg";
import { ReactComponent as IcMinusCircleWhite } from "../../assets/icons/ic_minus_circle_white.svg";
import { ReactComponent as IcPlusCircleWhite } from "../../assets/icons/ic_plus_circle_white.svg";
import { ReactComponent as IcBonusTransaction } from "../../assets/icons/ic_bonus_transaction.svg";
import { ReactComponent as IcPix } from "../../assets/icons/ic_pix.svg";
import { ReactComponent as IcGcash } from "../../assets/icons/ic_gcash.svg";
import { ReactComponent as IcPaymentMethod } from "../../assets/icons/ic_payment_method.svg";
import { ReactComponent as IcDot } from "../../assets/icons/ic_dot.svg";
import { ReactComponent as IcRefresh } from "../../assets/icons/ic_refresh.svg";
import { ReactComponent as IcHistory } from "../../assets/icons/ic_history.svg";

const iconsComponents = {
    IcAlibaba,
    IcAlibabaCircle,
    IcAmazon,
    IcAppStoreBadge,
    IcApple,
    IcAppleCircle,
    IcArrowLeft,
    IcArrowRight,
    IcAssetDefault,
    IcAttention,
    IcAttentionCircleWhite,
    IcBack,
    IcBank,
    IcBankCard,
    IcBankCardArrowRight,
    IcBinomoLogo,
    IcBitcoin,
    IcBonus,
    IcBonusStub,
    IcBonusTransaction,
    IcBrent,
    IcBtc,
    IcCard,
    IcChainLink,
    IcChartCandle,
    IcChartLine,
    IcChartStatistic,
    IcCheckCircle,
    IcCheckMark,
    IcCheckMarkCircle,
    IcCheckMarkCircleGreen,
    IcCheckMarkShield,
    IcChevronDown,
    IcChevronLeft,
    IcChevronRight,
    IcCircleSlashed,
    IcCisco,
    IcCiscoCircle,
    IcCiti,
    IcClock,
    IcClockBlackCircle,
    IcClose,
    IcCloseWhite,
    IcCoinStack,
    IcCopy,
    IcCountry,
    IcCoupon,
    IcDash,
    IcDelete,
    IcDocCopy,
    IcDocument,
    IcDollar,
    IcDollarRefresh,
    IcDot,
    IcDowJones,
    IcEbay,
    IcEducation,
    IcEmptyPage,
    IcEnvelope,
    IcEnvelopeCheckmark,
    IcEth,
    IcEthereum,
    IcExclamationMarkCircle,
    IcExclamationMarkTriangle,
    IcEyeOff,
    IcEyeOn,
    IcFacebook,
    IcFingerprint,
    IcFlags,
    IcFlagsChfUsd,
    IcFlagsEurUsd,
    IcFlagsJpyEur,
    IcFlagsJpyUsd,
    IcFlagsUkUsd,
    IcForward,
    IcGas,
    IcGcash,
    IcGear,
    IcGearApp,
    IcGold,
    IcGoldCircle,
    IcGooglePlayBadge,
    IcGraduationCap,
    IcGrowth,
    IcHarpoonLeftRight,
    IcHistory,
    IcHp,
    IcInfo,
    IcInfoCircle,
    IcInfoFilled,
    IcLtc,
    IcMenuBurger,
    IcMicrosoft,
    IcMinus,
    IcMinusCircleWhite,
    IcMoveLeft,
    IcNasdaq,
    IcNextRound,
    IcNgas,
    IcPassport,
    IcPaymentMethod,
    IcPencil,
    IcPerson,
    IcPersonGroup,
    IcPix,
    IcPlaceholder,
    IcPlay,
    IcPlus,
    IcPlusCircle,
    IcPlusCircleWhite,
    IcPortfolio,
    IcPound,
    IcQrCode,
    IcQuestionMarkBubble,
    IcRebuy,
    IcReduction,
    IcReferrals,
    IcRefresh,
    IcRespawn,
    IcSAndP,
    IcSAndPShort,
    IcSearch,
    IcSilverCircle,
    IcSquareArrowUpRight,
    IcStopwatch,
    IcTesla,
    IcTrades,
    IcTransaction,
    IcUnknownError,
    IcUsd,
    IcWallet,
    IcWarning,
    IcWithdraw,
    IcXCircle,
    IcXCircleRed,
    IcXMark,
    IcXMarkThin,
    Shield,
}

export const Icon = memo(({
    name,
    height = "1em",
    width = "1em",
    size,
    asComponent,
    style = {},
    defaultIcon,
    ...iconProps
}) => {
    if (!name) {
        return null;
    }
    if (asComponent && !iconsComponents[name]) {
        if (defaultIcon && iconsComponents[defaultIcon]) {
            name = defaultIcon;
        } else {
            return <></>
        }
    }
    const Component = iconsComponents[name];
    return asComponent
        ? <Component height={height} width={width} {...iconProps}
                     style={{fontSize: size || '1.5em', display: 'inline-block', lineHeight: 1.25, ...style}}/>
        : <img src={`${process.env.PUBLIC_URL}/assets/${name}.svg`} alt={name} height={height}
               width={width} {...iconProps}/>;
});

export const BinIcon = memo((props) => {
    return <Icon asComponent {...props}/>
});

export const IconAsset = memo(({symbol, type, size = '1.5em', ...iconProps}) => {
    return <img src={`${process.env.PUBLIC_URL}/assets/icons/symbols/${symbol}.png`}
                alt={''}
                style={{
                    width: size,
                    height: size,
                }}
                onError={({currentTarget}) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAAAP1BMVEUAAAC8v9q+v9u9v9u/v9u+v9u9v9u9vtu9v9u+v9u9v9y7v9u/v9e8v9u6v9q+v9u8v9u9v9u8vdi/v9+9v9tGitkDAAAAFHRSTlMAoJ/fIF/vkK+/b0AQzzDPv1BwMAzYPJwAAAG9SURBVFjD7djdboMwDIZhcAiEvwKb7/9at2kHtE3Ja1OpUqV+p0VPkxiixNUnb5hL7FII+puw9F28PIVNQ9/qXdoUm5Pc2OtB0naCi0ELCdE7uhLnJ5teDRHzWg6tmtJGW2k7NaezTHdWR5YGvaCuhIa90yJ7z4uznsgyHXpQX3eto57M18EClt7nui694Y+XsS555Z9774Rr+sPxARiKHogBBph5KEYYYOZlIg1xAy8TaRUTeJkIhW7IY3HKSgIeiV80493LRZ5zSx6L7fUj3+yxeH1KGdhjMWYbIXu7CNtizx6LKdv6wSMxVHsCeCDmIHhG8RoED0QExQYKgCCCdwuGE6JAlUFkT+fyZiNeT1f49MTpaUf7q/g8jbh9icvTC2+w4vHam2d6BRE9Tbc3CTWLYjo7TAoienp3pOtBRC/dX+4URPB0sx+WxOIFz3FO2NPoOnAKeqHKMyqIojhALPQulj3xXytErNcK/lw48VVXs2paznjzC6+3LLLHInsgLq71A89b626ytb2sjaDB3KqqLd7a+HpzkDC+oN0H2dLhZMfqXJqY8pbpOkBpIZehW+f/pm5If03dT94vP0CR6JwuY3X9AAAAAElFTkSuQmCC';
                }}
                {...iconProps}/>
});
